import { InfoCircleTwoTone } from '@ant-design/icons'
import { Image, Modal, Tooltip } from 'components/common'
import { SAGA_ARENA_USAGE_TYPE } from 'config'
import { calculateDaysBetween, calculateMinutes } from 'helper'
import { BookingDateInput, Period } from 'lib/graphql/storeadmin'
import priceFormat from 'lib/str-formatter/price'
import { FC, useState } from 'react'

export type LineItemProps = {
  date?: string
  isSagaArena: boolean
  isBookingDetails?: boolean
  loading?: boolean
  title: string
  variantTitle: string
  baseTimeUnit: number
  bookingDates?: BookingDateInput
  period: Period
  price: number
  specialPrice: number
  image?: string
  quantity?: number
  onDelete?: () => void
}

type LineHeaderProps = {
  isSagaArena: boolean
  isBookingDetails?: boolean
}

const isWeekendOrHoliday = (dateStr: string): boolean => {
  // Dateオブジェクトを作成
  const date = new Date(dateStr)

  // 土日の判定
  const day = date.getDay()
  if (day === 0 || day === 6) {
    return true
  }

  // TODO: ここに祝日か否かを判定するロジックを追加する

  return false
}

export const LineHeader: FC<LineHeaderProps> = (props): JSX.Element => {
  const { isSagaArena, isBookingDetails } = props

  return (
    <div className="grid grid-cols-2 mb-px">
      <div>予約対象施設</div>
      {isSagaArena ? (
        <div className="grid grid-cols-3">
          {isBookingDetails && <div></div>}
          <div className="text-center">数量</div>
          {!isBookingDetails && <div className="text-center">利用日数</div>}
          <div className="text-right">小計</div>
        </div>
      ) : (
        <div className="grid grid-cols-3">
          <div></div>
          {isBookingDetails ? (
            <div></div>
          ) : (
            <div className="text-center">利用日数</div>
          )}
          <div className="text-right">小計</div>
        </div>
      )}
    </div>
  )
}

export const LineItem: FC<LineItemProps> = (props): JSX.Element => {
  const {
    price,
    specialPrice,
    period,
    baseTimeUnit,
    bookingDates,
    date,
    image,
    title,
    variantTitle,
    isSagaArena,
    isBookingDetails,
    quantity,
  } = props
  const totalPrice =
    price * Math.ceil(calculateMinutes(period.start, period.end) / baseTimeUnit)
  const numberOfBookingDates = calculateDaysBetween(
    bookingDates?.start,
    bookingDates?.end
  )
  const [showModal, setShowModal] = useState(false)

  const isWeekend = isWeekendOrHoliday(date)
  const displayPrice = isWeekend && specialPrice > 0 ? specialPrice : price

  const isSetupTearDown = variantTitle.includes(
    SAGA_ARENA_USAGE_TYPE.SETUP_TEARDOWN
  )

  return (
    <div className="grid grid-cols-2">
      {/* 予約対象施設 */}
      <div className="flex space-x-6">
        <Image
          src={image || ''}
          preview={false}
          width={64}
          height={64}
          onClick={() => setShowModal(image && true)}
          className="cursor-pointer"
        />
        <div>
          <p className="font-bold mb-1">{title}</p>
          <p className="opacity-80 text-lg m-0">{variantTitle}</p>
          <p className="opacity-80 text-lg m-0">
            {priceFormat(displayPrice)} / {baseTimeUnit}分
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3">
        {/* スタイル調整用 */}
        {!isSagaArena && <div></div>}
        {isBookingDetails && <div></div>}
        {/* 数量 */}
        {isSagaArena && (
          <div className="text-center">
            {isBookingDetails ? (
              // 日付単位の数量を表示する
              <p className="m-0">{quantity}</p>
            ) : (
              // 予約単位の数量を表示する
              <p className="m-0">{totalPrice / price}</p>
            )}
          </div>
        )}
        {/* 利用日数 */}
        {!isBookingDetails && (
          <div className="text-center">
            <p>{numberOfBookingDates}日</p>
          </div>
        )}
        {/* 小計 */}
        <div className="text-right">
          {isBookingDetails ? (
            <>
              {isSagaArena && isSetupTearDown ? (
                <div className="flex items-center justify-end space-x-1">
                  {/* 最大料金の考慮(メインアリーナとサブアリーナが同時予約ができるようになれば必要)
                  {quantity > 10 && (
                    <Tooltip
                      title={
                        <span>
                          最大料金です。
                          <br />
                          設営・撤去の最大料金は催事料金の50%です。
                        </span>
                      }
                    >
                      <InfoCircleTwoTone />
                    </Tooltip>
                  )}
                  <p className="m-0">
                    
                    {priceFormat(
                      displayPrice * (quantity > 10 ? 10 : quantity)
                    )}
                  </p> */}
                  <p className="m-0">{priceFormat(displayPrice * quantity)}</p>
                </div>
              ) : (
                <p className="m-0">{priceFormat(displayPrice * quantity)}</p>
              )}
            </>
          ) : (
            <p className="m-0">
              {priceFormat(totalPrice * numberOfBookingDates)}
            </p>
          )}
          {isWeekend && specialPrice > 0 && (
            <p className="opacity-80 text-lg">(土日祝日価格)</p>
          )}
        </div>
      </div>

      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={640}
      >
        <img src={image || ''} alt="施設画像" />
      </Modal>
    </div>
  )
}
